export type ForcedLogoutReason = 'foreignInvitation';

const forcedLogoutReasonKey = 'forcedLogoutReason';

export const setForcedLogoutNotice = (reason: ForcedLogoutReason) => {
  sessionStorage.setItem(forcedLogoutReasonKey, reason);
};

// The notice is written before a full page load and read by the page that comes
// after it, so it is consumed once and dropped to avoid firing again on a later
// reload.
export const takeForcedLogoutNotice = (): ForcedLogoutReason | null => {
  const reason = sessionStorage.getItem(forcedLogoutReasonKey);

  sessionStorage.removeItem(forcedLogoutReasonKey);

  return reason as ForcedLogoutReason | null;
};
